import http from '../api'
import { InputUpdateUser, User } from '../user/types'
import {
  InputLoginCredential,
  InputRegisterUser,
  AuthResponse,
  TwoFactorCode,
  UploadedResponse,
  InputTwoFactorCode,
  InputRequestUser,
} from './types'

async function loginUser(input: InputLoginCredential) {
  return await http.post<AuthResponse>('auth/local/signin', input)
}

async function registerUser(input: InputRegisterUser) {
  return await http.post<AuthResponse>('auth/local/signup', input)
}

async function requestUser(input: InputRequestUser) {
  return await http.post<boolean>('auth/local/request-rpps', input)
}

async function verify2FA(input: InputTwoFactorCode) {
  return await http.post<AuthResponse>('auth/verify-2fa', input)
}

async function logoutUser() {
  return await http.post<boolean>('auth/logout')
}

async function requestResetPassword(email: string) {
  return await http.post<boolean>('auth/forgot-password', { email })
}

async function resetPassword(token: string, password: string) {
  return await http.post<boolean>('auth/reset-password', { token, password })
}

async function emailConfirmation() {
  return await http.post<boolean>('user/me/email-confirmation')
}

async function generate2FA() {
  return await http.post<TwoFactorCode>('user/me/generate-2fa')
}

async function enable2FA(input: InputTwoFactorCode) {
  return await http.post<User>('user/me/enable-2fa', input)
}

async function disable2FA() {
  return await http.post<User>('user/me/disable-2fa')
}

async function getProfile() {
  return await http.get<User>('user/me')
}

async function updateProfile(input: InputUpdateUser) {
  return await http.patch<User>('user/me', input)
}

async function updateAvatar(input: FormData) {
  return await http.post<UploadedResponse>('user/me/upload-avatar', input)
}

export default {
  loginUser,
  registerUser,
  requestUser,
  verify2FA,
  logoutUser,
  emailConfirmation,
  getProfile,
  updateProfile,
  updateAvatar,
  requestResetPassword,
  resetPassword,
  generate2FA,
  enable2FA,
  disable2FA,
}
